<app-login-header></app-login-header>

<div class="page-container login-wrapper" id="industry-profile-public-view">

  <div class="row" *ngIf="industryProfileDetail && industryProfileDetail.length && !getIndustryDetailLoader">
    <div class="col-lg-12" *ngIf="industryProfileDetail[0]">
      <div class="panel panel-flat">
        <div class="panel-heading">
          <span class="panel-title" style="font-size: 20px; font-weight: 900;">{{industryProfileDetail[0]?industryProfileDetail[0].name:'NA'}}</span><span style="font-size: 20px; margin-left: 1%;">({{industryProfileDetail[0]?industryProfileDetail[0].code:'NA'}})</span>
          <div style="font-size: 14px; font-weight: 500; color: #999;">{{industryProfileDetail[0]?industryProfileDetail[0].industry_type +' industry':'NA'}}</div>
          <div style="font-size: 14px; font-weight: 500; color: #999;">{{industryProfileDetail[0]?industryProfileDetail[0].address:'NA'}}</div>
          <div style="font-size: 14px; font-weight: 500; color: #999;">Last data received - {{industryProfileDetail[0]['last_update_date'] | date:'dd MMM yyyy HH:mm'}}</div>
          <div class="heading-elements">
            <!-- <img src="/assets/images/profile-icon/15.png" style="margin-top: -10%; margin-left: -5%;"> -->
            <img title="Online" *ngIf="(industryProfileDetail[0]['last_update_date'] | industryStatus) == 'Online'" src="/assets/images/profile-icon/online.png" style="margin-top: -10%; margin-left: 5%;">
            <img title="Offline" *ngIf="(industryProfileDetail[0]['last_update_date'] | industryStatus) == 'Offline'" src="/assets/images/profile-icon/offline.png" style="margin-top: -10%; margin-left: 5%;">
            <img title="Delay" *ngIf="(industryProfileDetail[0]['last_update_date'] | industryStatus) == 'Delay'" src="/assets/images/profile-icon/delay.png" style="margin-top: -10%; margin-left: 5%;">
          </div>
          <div style="position: absolute; right: 5%;">
            <a title="Take print out or save in this page in PDF." style="background-color: #EEF3F6; font-weight: 900 !important; color: #000 !important;" (click)="printPage()" class="btn border-primary text-primary btn-flat btn-icon btn-rounded btn-sm">
              <i class="icon icon-printer"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-12 text-center" *ngIf="!industryProfileDetail.length && !getIndustryDetailLoader" style="height: 180px;">
    <div class="label label-danger" style="margin-top: 100px;">Invalid Industry</div>
  </div>

  <div *ngIf="stationDeviceDetail && !getStationDeviceDetailsLoader">
    <div class="row" *ngFor="let industry of stationDeviceDetail | keyvalue">
      <!--<div class="row">-->
      <div class="col-lg-6" *ngFor="let station of industry.value | keyvalue">
        <div class="panel panel-body" style="height: 300px;">

          <div style="font-size: 16px; font-weight: 500; margin-bottom: -4%;">{{station.value.station_name}} <hr/></div>

          <div *ngIf="((industryProfileDetail[0]['last_update_date'] | industryStatus) == 'Online')">
            <div *ngIf="!getStationDeviceLatestResultLoader['stat_'+station.value.station_id] && (deviceResponseChart['stat_'+station.value.station_id])" [chart]="deviceResponseChart['stat_'+station.value.station_id]" class="chart-container" style="margin-top: 10%; height: 200px;"></div>
            <div *ngIf="!getStationDeviceLatestResultLoader['stat_'+station.value.station_id] && (!deviceResponseChart['stat_'+station.value.station_id])" class="col-lg-12 text-center"  style="height: 210px;">
              <div class="label label-danger" style="margin-top: 100px;">No Record Found</div>
            </div>
          </div>

          <div *ngIf="((industryProfileDetail[0]['last_update_date'] | industryStatus) != 'Online')">
            <div *ngIf="!getStationDeviceLatestResultLoader['stat_'+station.value.station_id]" class="col-lg-12 text-center"  style="height: 210px;">
              <div class="label label-danger" style="margin-top: 100px;">
                Industry is in {{industryProfileDetail[0]['last_update_date'] | industryStatus}} mode.
              </div>
            </div>
          </div>


          <div *ngIf="getStationDeviceLatestResultLoader['stat_'+station.value.station_id]" class="col-md-12" style="text-align: center">
            <img src="/assets/images/load.gif" />
          </div>

        </div>
      </div>

    </div>
  </div>

  <div class="col-md-12" style="text-align: center" *ngIf="getIndustryDetailLoader || getStationDeviceDetailsLoader">
    <img src="/assets/images/load.gif" />
  </div>
</div>
<app-footer></app-footer>
